/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

// FontAwesome: disabilita auto-injection PRIMA degli import dei CSS per evitare conflitti
import { config } from "@fortawesome/fontawesome-svg-core"

// Import Google Fonts (Creative-Tech style)
import "@fontsource/plus-jakarta-sans/400.css"
import "@fontsource/plus-jakarta-sans/500.css"
import "@fontsource/plus-jakarta-sans/600.css"
import "@fontsource/plus-jakarta-sans/700.css"
import "@fontsource/plus-jakarta-sans/800.css"
import "@fontsource/jetbrains-mono/400.css"
import "@fontsource/jetbrains-mono/500.css"

import "@fortawesome/fontawesome-svg-core/styles.css"

// Import Bootstrap CSS
import "bootstrap/dist/css/bootstrap.min.css"

// Custom global theme overrides (light/dark mode, component resets)
import "./src/index.css"

// Import CSS componenti locali
import "./src/components/images/ImageModal.css"

// FontAwesome config: deve essere DOPO tutti gli import
config.autoAddCss = false
config.autoA11y = false
